import { IHeaderLayout } from 'src/interfaces/layout';
import HeaderLayout from 'src/layouts/GenericScreenLayout/components/HeaderLayout';

const Header = ({
  title,
  titleVariant,
  secondTitle,
  subTitle,
  iconTitle,
  hasTabMenu,
  hasBackground,
  labelButton,
  iconButton,
  hasButtonGoBack,
  routeGoBack,
  handleOnClick,
  withProfileAvatar,
  actionButton
}: IHeaderLayout) => (
    <HeaderLayout
        title={title}
        titleVariant={titleVariant}
        secondTitle={secondTitle}
        subTitle={subTitle}
        iconTitle={iconTitle}
        hasBackground={hasBackground}
        hasTabMenu={hasTabMenu}
        labelButton={labelButton}
        iconButton={iconButton}
        hasButtonGoBack={hasButtonGoBack}
        routeGoBack={routeGoBack}
        handleOnClick={handleOnClick}
        withProfileAvatar={withProfileAvatar}
        actionButton={actionButton}
    />
);
Header.displayName = 'Header';
export default Header;
